import { BoundingInfo } from '@babylonjs/core/Culling/boundingInfo';
import { Space } from '@babylonjs/core/Maths/math.axis';
import { Quaternion, Vector3 } from '@babylonjs/core/Maths/math.vector';
import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh';

import { degreesToRadians } from '../../math/geom/degreesToRadians';

/**
 * to turn face to the front
 */
export const MAGIC_GLB_Z_SCALING = -1;

export const applyPreRendeingOptions = (root: AbstractMesh, options: PreRenderingOptions) => {
  const { rotation, scaling, translation } = { ...defaultOptions, ...options };
  /**
   * YXZ convention
   * https://doc.babylonjs.com/divingDeeper/mesh/transforms/center_origin/rotation_conventions#yxz-local-axes-yaw-pitch-roll
   */
  root.setPivotPoint(Vector3.Zero(), Space.LOCAL);
  // root.setPivotPoint(Vector3.Zero(), Space.WORLD);
  if (rotation) {
    const [x, y, z] = rotation.map(degreesToRadians);
    // root.rotate(Axis.Y, y, Space.WORLD);
    // root.rotate(Axis.X, x, Space.WORLD);
    // root.rotate(Axis.Z, z, Space.WORLD);
    const q = Quaternion.RotationYawPitchRoll(y, x, z);
    /**
     * In case of use rotation from file, please try:
     * root.rotationQuaternion.multiplyInPlace(q);
     */
    root.rotationQuaternion = q;
  }
  if (scaling) {
    const [x, y, z] = scaling;
    root.scaling = new Vector3(x, y, z * MAGIC_GLB_Z_SCALING);

    const { min, max } = root.getHierarchyBoundingVectors();
    const boundingInfo = new BoundingInfo(min, max);
    const centerPoint = boundingInfo.boundingBox.center.scale(-1);
    root.position = centerPoint;
  }
  if (translation) {
    root.setAbsolutePosition(Vector3.FromArray(translation));
    // root.translate(Axis.X, x || 0, Space.LOCAL);
    // root.translate(Axis.Y, y || 0, Space.LOCAL);
    // root.translate(Axis.Z, z || 0, Space.LOCAL);
  }
};
export interface PreRenderingOptions {
  scaling?: number[];
  rotation?: number[];
  translation?: number[];
}

const defaultOptions = {
  scaling: [1, 1, 1],
  rotation: [0, 0, 0],
  translation: [0, 0, 0],
};
